import { Subject } from 'rxjs';
import {
  isDataTransformAdapter,
  QtControlAdapter,
  QtDataTransformAdapter,
} from './qt-control-adapter';

export class QtControlRegistry<T = unknown> {
  private readonly _adapters = new Map<string, QtControlAdapter>();

  /** Emits whenever the adapter set changes. */
  readonly changes$ = new Subject<void>();

  register(adapter: QtControlAdapter): void {
    const id = adapter.key ?? `__anon_${this._adapters.size}`;
    this._adapters.set(id, adapter);
    this.changes$.next();
  }

  unregister(key: string): void {
    this._adapters.delete(key);
    this.changes$.next();
  }

  get<TState>(key: string): QtControlAdapter<TState> | undefined {
    return this._adapters.get(key) as QtControlAdapter<TState>;
  }

  getAll(): QtControlAdapter[] {
    return [...this._adapters.values()];
  }

  /** Adapters included in state persistence (key set and persistent !== false). */
  getPersistable(): QtControlAdapter[] {
    return this.getAll().filter(a => !!a.key && a.persistent !== false);
  }

  /** Adapters that transform data, sorted by pipeOrder ascending. */
  getDataTransforms(): QtDataTransformAdapter<T>[] {
    return this.getAll()
      .filter(isDataTransformAdapter<T>)
      .sort((a, b) => a.pipeOrder - b.pipeOrder) as QtDataTransformAdapter<T>[];
  }

  destroy(): void {
    this.changes$.complete();
  }
}
